var _rect, _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path10, _mask6, _path11, _path12, _rect2, _rect3, _mask7, _path13, _path14, _mask8, _path15, _path16, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _mask9, _path17, _path18, _path19, _path20, _mask10, _path21, _path22, _path23, _path24, _mask11, _path25, _path26, _path27, _path28, _mask12, _path29, _path30, _path31, _path32, _mask13, _path33, _path34, _path35, _path36, _mask14, _path37, _path38, _path39, _path40, _mask15, _path41, _path42, _path43, _path44, _mask16, _path45, _path46, _path47, _path48, _mask17, _path49, _path50, _path51, _path52, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _mask18, _path53, _path54, _line, _mask19, _path55, _path56, _line2, _line3, _path57, _path58, _path59, _line4, _path60, _path61, _path62, _line5, _path63, _path64, _path65;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnessetInBreake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 87,
    viewBox: "0 0 275 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.4668,
    y: 37.6753,
    width: 224.208,
    height: 41.2721,
    rx: 2.5,
    fill: "white",
    stroke: "#303030"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.666 38.2964C224.666 37.7441 225.114 37.2964 225.666 37.2964H227.31C227.862 37.2964 228.31 37.7441 228.31 38.2964V44.3135C228.31 44.8658 227.862 45.3135 227.31 45.3135H225.666C225.114 45.3135 224.666 44.8658 224.666 44.3135V38.2964Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.666 38.2964C224.666 37.7441 225.114 37.2964 225.666 37.2964H227.31C227.862 37.2964 228.31 37.7441 228.31 38.2964V44.3135C228.31 44.8658 227.862 45.3135 227.31 45.3135H225.666C225.114 45.3135 224.666 44.8658 224.666 44.3135V38.2964Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.666 37.2964H228.31H224.666ZM228.31 45.3135H224.666H228.31ZM225.666 45.3135C224.561 45.3135 223.666 44.4181 223.666 43.3135V39.2964C223.666 38.1918 224.561 37.2964 225.666 37.2964C225.666 37.2964 225.666 37.7441 225.666 38.2964V44.3135C225.666 44.8658 225.666 45.3135 225.666 45.3135ZM227.31 37.2964C228.415 37.2964 229.31 38.1918 229.31 39.2964V43.3135C229.31 44.4181 228.415 45.3135 227.31 45.3135C227.31 45.3135 227.31 44.8658 227.31 44.3135V38.2964C227.31 37.7441 227.31 37.2964 227.31 37.2964Z",
    fill: "#303030",
    mask: "url(#path-2-inside-1_127_731)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.072 38.2964C202.072 37.7441 202.52 37.2964 203.072 37.2964H204.716C205.269 37.2964 205.716 37.7441 205.716 38.2964V44.3135C205.716 44.8658 205.269 45.3135 204.716 45.3135H203.072C202.52 45.3135 202.072 44.8658 202.072 44.3135V38.2964Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.072 38.2964C202.072 37.7441 202.52 37.2964 203.072 37.2964H204.716C205.269 37.2964 205.716 37.7441 205.716 38.2964V44.3135C205.716 44.8658 205.269 45.3135 204.716 45.3135H203.072C202.52 45.3135 202.072 44.8658 202.072 44.3135V38.2964Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.072 37.2964H205.716H202.072ZM205.716 45.3135H202.072H205.716ZM203.072 45.3135C201.968 45.3135 201.072 44.4181 201.072 43.3135V39.2964C201.072 38.1918 201.968 37.2964 203.072 37.2964C203.072 37.2964 203.072 37.7441 203.072 38.2964V44.3135C203.072 44.8658 203.072 45.3135 203.072 45.3135ZM204.716 37.2964C205.821 37.2964 206.716 38.1918 206.716 39.2964V43.3135C206.716 44.4181 205.821 45.3135 204.716 45.3135C204.716 45.3135 204.716 44.8658 204.716 44.3135V38.2964C204.716 37.7441 204.716 37.2964 204.716 37.2964Z",
    fill: "#303030",
    mask: "url(#path-4-inside-2_127_731)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.292 38.2964C177.292 37.7441 177.74 37.2964 178.292 37.2964H179.936C180.488 37.2964 180.936 37.7441 180.936 38.2964V44.3135C180.936 44.8658 180.488 45.3135 179.936 45.3135H178.292C177.74 45.3135 177.292 44.8658 177.292 44.3135V38.2964Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.292 38.2964C177.292 37.7441 177.74 37.2964 178.292 37.2964H179.936C180.488 37.2964 180.936 37.7441 180.936 38.2964V44.3135C180.936 44.8658 180.488 45.3135 179.936 45.3135H178.292C177.74 45.3135 177.292 44.8658 177.292 44.3135V38.2964Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.292 37.2964H180.936H177.292ZM180.936 45.3135H177.292H180.936ZM178.292 45.3135C177.187 45.3135 176.292 44.4181 176.292 43.3135V39.2964C176.292 38.1918 177.187 37.2964 178.292 37.2964C178.292 37.2964 178.292 37.7441 178.292 38.2964V44.3135C178.292 44.8658 178.292 45.3135 178.292 45.3135ZM179.936 37.2964C181.041 37.2964 181.936 38.1918 181.936 39.2964V43.3135C181.936 44.4181 181.041 45.3135 179.936 45.3135C179.936 45.3135 179.936 44.8658 179.936 44.3135V38.2964C179.936 37.7441 179.936 37.2964 179.936 37.2964Z",
    fill: "#303030",
    mask: "url(#path-6-inside-3_127_731)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.241 38.2964C153.241 37.7441 153.688 37.2964 154.241 37.2964H155.885C156.437 37.2964 156.885 37.7441 156.885 38.2964V44.3135C156.885 44.8658 156.437 45.3135 155.885 45.3135H154.241C153.688 45.3135 153.241 44.8658 153.241 44.3135V38.2964Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 38.2964C153.241 37.7441 153.688 37.2964 154.241 37.2964H155.885C156.437 37.2964 156.885 37.7441 156.885 38.2964V44.3135C156.885 44.8658 156.437 45.3135 155.885 45.3135H154.241C153.688 45.3135 153.241 44.8658 153.241 44.3135V38.2964Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 37.2964H156.885H153.241ZM156.885 45.3135H153.241H156.885ZM154.241 45.3135C153.136 45.3135 152.241 44.4181 152.241 43.3135V39.2964C152.241 38.1918 153.136 37.2964 154.241 37.2964C154.241 37.2964 154.241 37.7441 154.241 38.2964V44.3135C154.241 44.8658 154.241 45.3135 154.241 45.3135ZM155.885 37.2964C156.989 37.2964 157.885 38.1918 157.885 39.2964V43.3135C157.885 44.4181 156.989 45.3135 155.885 45.3135C155.885 45.3135 155.885 44.8658 155.885 44.3135V38.2964C155.885 37.7441 155.885 37.2964 155.885 37.2964Z",
    fill: "#303030",
    mask: "url(#path-8-inside-4_127_731)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.002 38.2964C127.002 37.7441 127.45 37.2964 128.002 37.2964H129.647C130.199 37.2964 130.647 37.7441 130.647 38.2964V44.3135C130.647 44.8658 130.199 45.3135 129.647 45.3135H128.002C127.45 45.3135 127.002 44.8658 127.002 44.3135V38.2964Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.002 38.2964C127.002 37.7441 127.45 37.2964 128.002 37.2964H129.647C130.199 37.2964 130.647 37.7441 130.647 38.2964V44.3135C130.647 44.8658 130.199 45.3135 129.647 45.3135H128.002C127.45 45.3135 127.002 44.8658 127.002 44.3135V38.2964Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.002 37.2964H130.647H127.002ZM130.647 45.3135H127.002H130.647ZM128.002 45.3135C126.898 45.3135 126.002 44.4181 126.002 43.3135V39.2964C126.002 38.1918 126.898 37.2964 128.002 37.2964C128.002 37.2964 128.002 37.7441 128.002 38.2964V44.3135C128.002 44.8658 128.002 45.3135 128.002 45.3135ZM129.647 37.2964C130.751 37.2964 131.647 38.1918 131.647 39.2964V43.3135C131.647 44.4181 130.751 45.3135 129.647 45.3135C129.647 45.3135 129.647 44.8658 129.647 44.3135V38.2964C129.647 37.7441 129.647 37.2964 129.647 37.2964Z",
    fill: "#303030",
    mask: "url(#path-10-inside-5_127_731)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-6_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.494 38.2964C101.494 37.7441 101.942 37.2964 102.494 37.2964H104.138C104.691 37.2964 105.138 37.7441 105.138 38.2964V44.3135C105.138 44.8658 104.691 45.3135 104.138 45.3135H102.494C101.942 45.3135 101.494 44.8658 101.494 44.3135V38.2964Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.494 38.2964C101.494 37.7441 101.942 37.2964 102.494 37.2964H104.138C104.691 37.2964 105.138 37.7441 105.138 38.2964V44.3135C105.138 44.8658 104.691 45.3135 104.138 45.3135H102.494C101.942 45.3135 101.494 44.8658 101.494 44.3135V38.2964Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.494 37.2964H105.138H101.494ZM105.138 45.3135H101.494H105.138ZM102.494 45.3135C101.39 45.3135 100.494 44.4181 100.494 43.3135V39.2964C100.494 38.1918 101.39 37.2964 102.494 37.2964C102.494 37.2964 102.494 37.7441 102.494 38.2964V44.3135C102.494 44.8658 102.494 45.3135 102.494 45.3135ZM104.138 37.2964C105.243 37.2964 106.138 38.1918 106.138 39.2964V43.3135C106.138 44.4181 105.243 45.3135 104.138 45.3135C104.138 45.3135 104.138 44.8658 104.138 44.3135V38.2964C104.138 37.7441 104.138 37.2964 104.138 37.2964Z",
    fill: "#303030",
    mask: "url(#path-12-inside-6_127_731)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 127.316,
    y: 44.9636,
    width: 2.64415,
    height: 18.6784,
    rx: 0.5,
    fill: "white",
    stroke: "#303030"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101.807,
    y: 44.9636,
    width: 2.64415,
    height: 18.6784,
    rx: 0.5,
    fill: "white",
    stroke: "#303030"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-7_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.7134 38.2964C76.7134 37.7441 77.1611 37.2964 77.7134 37.2964H79.3575C79.9098 37.2964 80.3575 37.7441 80.3575 38.2964V44.3135C80.3575 44.8658 79.9098 45.3135 79.3575 45.3135H77.7134C77.1611 45.3135 76.7134 44.8658 76.7134 44.3135V38.2964Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7134 38.2964C76.7134 37.7441 77.1611 37.2964 77.7134 37.2964H79.3575C79.9098 37.2964 80.3575 37.7441 80.3575 38.2964V44.3135C80.3575 44.8658 79.9098 45.3135 79.3575 45.3135H77.7134C77.1611 45.3135 76.7134 44.8658 76.7134 44.3135V38.2964Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7134 37.2964H80.3575H76.7134ZM80.3575 45.3135H76.7134H80.3575ZM77.7134 45.3135C76.6088 45.3135 75.7134 44.4181 75.7134 43.3135V39.2964C75.7134 38.1918 76.6088 37.2964 77.7134 37.2964C77.7134 37.2964 77.7134 37.7441 77.7134 38.2964V44.3135C77.7134 44.8658 77.7134 45.3135 77.7134 45.3135ZM79.3575 37.2964C80.4621 37.2964 81.3575 38.1918 81.3575 39.2964V43.3135C81.3575 44.4181 80.4621 45.3135 79.3575 45.3135C79.3575 45.3135 79.3575 44.8658 79.3575 44.3135V38.2964C79.3575 37.7441 79.3575 37.2964 79.3575 37.2964Z",
    fill: "#303030",
    mask: "url(#path-16-inside-7_127_731)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-8_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7466 38.2964C49.7466 37.7441 50.1943 37.2964 50.7466 37.2964H52.3907C52.943 37.2964 53.3907 37.7441 53.3907 38.2964V44.3135C53.3907 44.8658 52.943 45.3135 52.3907 45.3135H50.7466C50.1943 45.3135 49.7466 44.8658 49.7466 44.3135V38.2964Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7466 38.2964C49.7466 37.7441 50.1943 37.2964 50.7466 37.2964H52.3907C52.943 37.2964 53.3907 37.7441 53.3907 38.2964V44.3135C53.3907 44.8658 52.943 45.3135 52.3907 45.3135H50.7466C50.1943 45.3135 49.7466 44.8658 49.7466 44.3135V38.2964Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7466 37.2964H53.3907H49.7466ZM53.3907 45.3135H49.7466H53.3907ZM50.7466 45.3135C49.642 45.3135 48.7466 44.4181 48.7466 43.3135V39.2964C48.7466 38.1918 49.642 37.2964 50.7466 37.2964C50.7466 37.2964 50.7466 37.7441 50.7466 38.2964V44.3135C50.7466 44.8658 50.7466 45.3135 50.7466 45.3135ZM52.3907 37.2964C53.4953 37.2964 54.3907 38.1918 54.3907 39.2964V43.3135C54.3907 44.4181 53.4953 45.3135 52.3907 45.3135C52.3907 45.3135 52.3907 44.8658 52.3907 44.3135V38.2964C52.3907 37.7441 52.3907 37.2964 52.3907 37.2964Z",
    fill: "#303030",
    mask: "url(#path-18-inside-8_127_731)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 242.139,
    y: 54.8804,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 242.139 54.8804)",
    fill: "#303030"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 230.31,
    y: 54.8193,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 230.31 54.8193)",
    fill: "#303030"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 218.481,
    y: 54.7588,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 218.481 54.7588)",
    fill: "#303030"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 206.652,
    y: 54.6978,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 206.652 54.6978)",
    fill: "#303030"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 194.822,
    y: 54.637,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 194.822 54.637)",
    fill: "#303030"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 182.265,
    y: 54.5762,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 182.265 54.5762)",
    fill: "#303030"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 158.885,
    y: 55.9355,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    fill: "#303030"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 147.224,
    y: 55.9355,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    fill: "#303030"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 134.104,
    y: 55.9355,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    fill: "#303030"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 122.443,
    y: 55.9355,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    fill: "#303030"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 109.324,
    y: 55.9355,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    fill: "#303030"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 96.2056,
    y: 55.9355,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    fill: "#303030"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 84.5439,
    y: 55.9355,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    fill: "#303030"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7773,
    y: 55.8875,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(5 71.7773 55.8875)",
    fill: "#303030"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 59.3877,
    y: 56.1248,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(5 59.3877 56.1248)",
    fill: "#303030"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 46.269,
    y: 56.1248,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(5 46.269 56.1248)",
    fill: "#303030"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6069,
    y: 56.1248,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(5 34.6069 56.1248)",
    fill: "#303030"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 70.666,
    y: 67.7861,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(5 70.666 67.7861)",
    fill: "#303030"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2759,
    y: 68.0237,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(5 58.2759 68.0237)",
    fill: "#303030"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1572,
    y: 68.0237,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(5 45.1572 68.0237)",
    fill: "#303030"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4961,
    y: 68.0237,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(5 33.4961 68.0237)",
    fill: "#303030"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 243.597,
    y: 66.6499,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 243.597 66.6499)",
    fill: "#303030"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 231.768,
    y: 66.5891,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 231.768 66.5891)",
    fill: "#303030"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 219.938,
    y: 66.5283,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 219.938 66.5283)",
    fill: "#303030"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 208.109,
    y: 66.4675,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 208.109 66.4675)",
    fill: "#303030"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 196.28,
    y: 66.4065,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 196.28 66.4065)",
    fill: "#303030"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 183.722,
    y: 66.3457,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    transform: "rotate(-6 183.722 66.3457)",
    fill: "#303030"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 158.885,
    y: 67.7051,
    width: 1.45766,
    height: 8.01712,
    rx: 0.2,
    fill: "#303030"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 153.442,
    y: 45.0747,
    width: 2.64415,
    height: 33.9838,
    rx: 0.5,
    transform: "rotate(-3 153.442 45.0747)",
    fill: "white",
    stroke: "#303030"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 77.3735,
    y: 44.9361,
    width: 2.64415,
    height: 33.9838,
    rx: 0.5,
    transform: "rotate(3 77.3735 44.9361)",
    fill: "white",
    stroke: "#303030"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4067,
    y: 44.9361,
    width: 2.64415,
    height: 33.9838,
    rx: 0.5,
    transform: "rotate(3 50.4067 44.9361)",
    fill: "white",
    stroke: "#303030"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 202.411,
    y: 45.0747,
    width: 2.64415,
    height: 33.9838,
    rx: 0.5,
    transform: "rotate(-3 202.411 45.0747)",
    fill: "white",
    stroke: "#303030"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 177.631,
    y: 45.0747,
    width: 2.64415,
    height: 33.9838,
    rx: 0.5,
    transform: "rotate(-3 177.631 45.0747)",
    fill: "white",
    stroke: "#303030"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 225.005,
    y: 45.0747,
    width: 2.64415,
    height: 33.9838,
    rx: 0.5,
    transform: "rotate(-3 225.005 45.0747)",
    fill: "white",
    stroke: "#303030"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-54-inside-9_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.644 45.2658C231.615 44.9912 231.814 44.7452 232.089 44.7163L235.443 44.3637C235.718 44.3349 235.964 44.5341 235.993 44.8087L239.393 77.1567C239.421 77.4313 239.222 77.6773 238.948 77.7062L235.593 78.0588C235.318 78.0876 235.072 77.8884 235.043 77.6138L231.644 45.2658Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.644 45.2658C231.615 44.9912 231.814 44.7452 232.089 44.7163L235.443 44.3637C235.718 44.3349 235.964 44.5341 235.993 44.8087L239.393 77.1567C239.421 77.4313 239.222 77.6773 238.948 77.7062L235.593 78.0588C235.318 78.0876 235.072 77.8884 235.043 77.6138L231.644 45.2658Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M231.591 44.7686L235.94 44.3115L231.591 44.7686ZM239.445 77.6539L235.096 78.111L239.445 77.6539ZM235.593 78.0588C234.769 78.1454 234.031 77.5477 233.944 76.7238L230.754 46.3649C230.667 45.541 231.265 44.8029 232.089 44.7163L232.586 44.664C232.586 44.664 232.609 44.8867 232.638 45.1613L236.038 77.5093C236.067 77.7839 236.09 78.0065 236.09 78.0065L235.593 78.0588ZM235.443 44.3637C236.267 44.2771 237.005 44.8748 237.092 45.6987L240.282 76.0576C240.369 76.8815 239.771 77.6196 238.948 77.7062L238.45 77.7585C238.45 77.7585 238.427 77.5358 238.398 77.2612L234.998 44.9132C234.969 44.6386 234.946 44.416 234.946 44.416L235.443 44.3637Z",
    fill: "#9B9A95",
    mask: "url(#path-54-inside-9_127_731)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M235.927 62.0799L235.595 62.3391L235.974 62.5237L235.927 62.0799Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M235.579 62.1164L235.957 62.3009L235.626 62.5602L235.579 62.1164Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-58-inside-10_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.498 45.2658C208.469 44.9912 208.668 44.7452 208.943 44.7163L212.297 44.3637C212.572 44.3349 212.818 44.5341 212.847 44.8087L216.247 77.1567C216.275 77.4313 216.076 77.6773 215.802 77.7062L212.447 78.0588C212.172 78.0876 211.926 77.8884 211.897 77.6138L208.498 45.2658Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M208.498 45.2658C208.469 44.9912 208.668 44.7452 208.943 44.7163L212.297 44.3637C212.572 44.3349 212.818 44.5341 212.847 44.8087L216.247 77.1567C216.275 77.4313 216.076 77.6773 215.802 77.7062L212.447 78.0588C212.172 78.0876 211.926 77.8884 211.897 77.6138L208.498 45.2658Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M208.445 44.7686L212.794 44.3115L208.445 44.7686ZM216.299 77.6539L211.95 78.111L216.299 77.6539ZM212.447 78.0588C211.623 78.1454 210.885 77.5477 210.798 76.7238L207.608 46.3649C207.521 45.541 208.119 44.8029 208.943 44.7163L209.44 44.664C209.44 44.664 209.463 44.8867 209.492 45.1613L212.892 77.5093C212.921 77.7839 212.944 78.0065 212.944 78.0065L212.447 78.0588ZM212.297 44.3637C213.121 44.2771 213.859 44.8748 213.946 45.6987L217.136 76.0576C217.223 76.8815 216.625 77.6196 215.802 77.7062L215.304 77.7585C215.304 77.7585 215.281 77.5358 215.252 77.2612L211.852 44.9132C211.823 44.6386 211.8 44.416 211.8 44.416L212.297 44.3637Z",
    fill: "#9B9A95",
    mask: "url(#path-58-inside-10_127_731)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M212.781 62.0799L212.449 62.3391L212.828 62.5237L212.781 62.0799Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M212.433 62.1164L212.811 62.3009L212.48 62.5602L212.433 62.1164Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-62-inside-11_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.894 45.2658C183.865 44.9912 184.064 44.7452 184.339 44.7163L187.693 44.3637C187.968 44.3349 188.214 44.5341 188.243 44.8087L191.643 77.1567C191.671 77.4313 191.472 77.6773 191.198 77.7062L187.843 78.0588C187.568 78.0876 187.322 77.8884 187.293 77.6138L183.894 45.2658Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M183.894 45.2658C183.865 44.9912 184.064 44.7452 184.339 44.7163L187.693 44.3637C187.968 44.3349 188.214 44.5341 188.243 44.8087L191.643 77.1567C191.671 77.4313 191.472 77.6773 191.198 77.7062L187.843 78.0588C187.568 78.0876 187.322 77.8884 187.293 77.6138L183.894 45.2658Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.841 44.7686L188.19 44.3115L183.841 44.7686ZM191.695 77.6539L187.346 78.111L191.695 77.6539ZM187.843 78.0588C187.019 78.1454 186.281 77.5477 186.194 76.7238L183.004 46.3649C182.917 45.541 183.515 44.8029 184.339 44.7163L184.836 44.664C184.836 44.664 184.859 44.8867 184.888 45.1613L188.288 77.5093C188.317 77.7839 188.34 78.0065 188.34 78.0065L187.843 78.0588ZM187.693 44.3637C188.517 44.2771 189.255 44.8748 189.342 45.6987L192.532 76.0576C192.619 76.8815 192.021 77.6196 191.198 77.7062L190.7 77.7585C190.7 77.7585 190.677 77.5358 190.648 77.2612L187.248 44.9132C187.219 44.6386 187.196 44.416 187.196 44.416L187.693 44.3637Z",
    fill: "#9B9A95",
    mask: "url(#path-62-inside-11_127_731)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M188.178 62.0799L187.846 62.3391L188.224 62.5237L188.178 62.0799Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.829 62.1164L188.207 62.3009L187.876 62.5602L187.829 62.1164Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-66-inside-12_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.019 45.2658C159.99 44.9912 160.189 44.7452 160.464 44.7163L163.819 44.3637C164.093 44.3349 164.339 44.5341 164.368 44.8087L167.768 77.1567C167.797 77.4313 167.598 77.6773 167.323 77.7062L163.968 78.0588C163.694 78.0876 163.448 77.8884 163.419 77.6138L160.019 45.2658Z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M160.019 45.2658C159.99 44.9912 160.189 44.7452 160.464 44.7163L163.819 44.3637C164.093 44.3349 164.339 44.5341 164.368 44.8087L167.768 77.1567C167.797 77.4313 167.598 77.6773 167.323 77.7062L163.968 78.0588C163.694 78.0876 163.448 77.8884 163.419 77.6138L160.019 45.2658Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M159.967 44.7686L164.316 44.3115L159.967 44.7686ZM167.82 77.6539L163.471 78.111L167.82 77.6539ZM163.968 78.0588C163.145 78.1454 162.407 77.5477 162.32 76.7238L159.129 46.3649C159.042 45.541 159.64 44.8029 160.464 44.7163L160.961 44.664C160.961 44.664 160.985 44.8867 161.014 45.1613L164.413 77.5093C164.442 77.7839 164.466 78.0065 164.466 78.0065L163.968 78.0588ZM163.819 44.3637C164.642 44.2771 165.381 44.8748 165.467 45.6987L168.658 76.0576C168.745 76.8815 168.147 77.6196 167.323 77.7062L166.826 77.7585C166.826 77.7585 166.802 77.5358 166.773 77.2612L163.374 44.9132C163.345 44.6386 163.321 44.416 163.321 44.416L163.819 44.3637Z",
    fill: "#9B9A95",
    mask: "url(#path-66-inside-12_127_731)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M164.303 62.0799L163.971 62.3391L164.35 62.5237L164.303 62.0799Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M163.954 62.1164L164.333 62.3009L164.001 62.5602L163.954 62.1164Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-70-inside-13_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4428 44.8182C67.4668 44.5431 67.7093 44.3396 67.9844 44.3636L71.3446 44.6576C71.6197 44.6817 71.8232 44.9242 71.7991 45.1993L68.9642 77.6017C68.9402 77.8768 68.6977 78.0803 68.4226 78.0562L65.0624 77.7622C64.7873 77.7381 64.5838 77.4956 64.6079 77.2205L67.4428 44.8182Z"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4428 44.8182C67.4668 44.5431 67.7093 44.3396 67.9844 44.3636L71.3446 44.6576C71.6197 44.6817 71.8232 44.9242 71.7991 45.1993L68.9642 77.6017C68.9402 77.8768 68.6977 78.0803 68.4226 78.0562L65.0624 77.7622C64.7873 77.7381 64.5838 77.4956 64.6079 77.2205L67.4428 44.8182Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4863 44.3201L71.8427 44.7012L67.4863 44.3201ZM68.9207 78.0998L64.5643 77.7186L68.9207 78.0998ZM65.0624 77.7622C64.2372 77.69 63.6267 76.9625 63.6989 76.1372L66.3594 45.7272C66.4316 44.9019 67.1592 44.2914 67.9844 44.3636L68.4825 44.4072C68.4825 44.4072 68.463 44.6302 68.4389 44.9053L65.6041 77.3077C65.58 77.5828 65.5605 77.8058 65.5605 77.8058L65.0624 77.7622ZM71.3446 44.6576C72.1698 44.7298 72.7803 45.4574 72.7081 46.2826L70.0476 76.6926C69.9754 77.5179 69.2478 78.1284 68.4226 78.0562L67.9245 78.0126C67.9245 78.0126 67.944 77.7896 67.9681 77.5145L70.8029 45.1121C70.827 44.837 70.8465 44.614 70.8465 44.614L71.3446 44.6576Z",
    fill: "#9B9A95",
    mask: "url(#path-70-inside-13_127_731)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1243 62.5235L68.5026 62.3389L68.1709 62.0797L68.1243 62.5235Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4725 62.56L68.1408 62.3008L68.5192 62.1162L68.4725 62.56Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-74-inside-14_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.511 45.4636C111.511 44.9113 111.958 44.4636 112.511 44.4636H114.884C115.436 44.4636 115.884 44.9113 115.884 45.4636V62.4132C115.884 62.9655 115.436 63.4132 114.884 63.4132H112.511C111.958 63.4132 111.511 62.9655 111.511 62.4132V45.4636Z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M111.511 45.4636C111.511 44.9113 111.958 44.4636 112.511 44.4636H114.884C115.436 44.4636 115.884 44.9113 115.884 45.4636V62.4132C115.884 62.9655 115.436 63.4132 114.884 63.4132H112.511C111.958 63.4132 111.511 62.9655 111.511 62.4132V45.4636Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M111.511 44.4636H115.884H111.511ZM115.884 63.4132H111.511H115.884ZM112.511 63.4132C111.406 63.4132 110.511 62.5178 110.511 61.4132V46.4636C110.511 45.3591 111.406 44.4636 112.511 44.4636C112.511 44.4636 112.511 44.9113 112.511 45.4636V62.4132C112.511 62.9655 112.511 63.4132 112.511 63.4132ZM114.884 44.4636C115.988 44.4636 116.884 45.3591 116.884 46.4636V61.4132C116.884 62.5178 115.988 63.4132 114.884 63.4132C114.884 63.4132 114.884 62.9655 114.884 62.4132V45.4636C114.884 44.9113 114.884 44.4636 114.884 44.4636Z",
    fill: "#9B9A95",
    mask: "url(#path-74-inside-14_127_731)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M113.763 55.2546L114.12 55.0315L113.763 54.8084V55.2546Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.113 55.2546L113.756 55.0315L114.113 54.8084V55.2546Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-78-inside-15_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.342 45.4636C117.342 44.9113 117.79 44.4636 118.342 44.4636H120.715C121.267 44.4636 121.715 44.9113 121.715 45.4636V62.4132C121.715 62.9655 121.267 63.4132 120.715 63.4132H118.342C117.79 63.4132 117.342 62.9655 117.342 62.4132V45.4636Z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M117.342 45.4636C117.342 44.9113 117.79 44.4636 118.342 44.4636H120.715C121.267 44.4636 121.715 44.9113 121.715 45.4636V62.4132C121.715 62.9655 121.267 63.4132 120.715 63.4132H118.342C117.79 63.4132 117.342 62.9655 117.342 62.4132V45.4636Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M117.342 44.4636H121.715H117.342ZM121.715 63.4132H117.342H121.715ZM118.342 63.4132C117.237 63.4132 116.342 62.5178 116.342 61.4132V46.4636C116.342 45.3591 117.237 44.4636 118.342 44.4636C118.342 44.4636 118.342 44.9113 118.342 45.4636V62.4132C118.342 62.9655 118.342 63.4132 118.342 63.4132ZM120.715 44.4636C121.819 44.4636 122.715 45.3591 122.715 46.4636V61.4132C122.715 62.5178 121.819 63.4132 120.715 63.4132C120.715 63.4132 120.715 62.9655 120.715 62.4132V45.4636C120.715 44.9113 120.715 44.4636 120.715 44.4636Z",
    fill: "#9B9A95",
    mask: "url(#path-78-inside-15_127_731)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M119.594 55.2546L119.951 55.0315L119.594 54.8084V55.2546Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M119.945 55.2546L119.588 55.0315L119.945 54.8084V55.2546Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-82-inside-16_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0604 44.8182C42.0845 44.5431 42.327 44.3396 42.6021 44.3636L45.9622 44.6576C46.2373 44.6817 46.4408 44.9242 46.4168 45.1993L43.5819 77.6017C43.5579 77.8768 43.3153 78.0803 43.0402 78.0562L39.6801 77.7622C39.405 77.7381 39.2015 77.4956 39.2256 77.2205L42.0604 44.8182Z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0604 44.8182C42.0845 44.5431 42.327 44.3396 42.6021 44.3636L45.9622 44.6576C46.2373 44.6817 46.4408 44.9242 46.4168 45.1993L43.5819 77.6017C43.5579 77.8768 43.3153 78.0803 43.0402 78.0562L39.6801 77.7622C39.405 77.7381 39.2015 77.4956 39.2256 77.2205L42.0604 44.8182Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42.104 44.3201L46.4603 44.7012L42.104 44.3201ZM43.5383 78.0998L39.182 77.7186L43.5383 78.0998ZM39.6801 77.7622C38.8548 77.69 38.2443 76.9625 38.3165 76.1372L40.9771 45.7272C41.0493 44.9019 41.7768 44.2914 42.6021 44.3636L43.1002 44.4072C43.1002 44.4072 43.0807 44.6302 43.0566 44.9053L40.2218 77.3077C40.1977 77.5828 40.1782 77.8058 40.1782 77.8058L39.6801 77.7622ZM45.9622 44.6576C46.7875 44.7298 47.398 45.4574 47.3258 46.2826L44.6653 76.6926C44.5931 77.5179 43.8655 78.1284 43.0402 78.0562L42.5421 78.0126C42.5421 78.0126 42.5617 77.7896 42.5857 77.5145L45.4206 45.1121C45.4446 44.837 45.4641 44.614 45.4641 44.614L45.9622 44.6576Z",
    fill: "#9B9A95",
    mask: "url(#path-82-inside-16_127_731)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7424 62.5235L43.1208 62.3389L42.7891 62.0797L42.7424 62.5235Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0907 62.56L42.759 62.3008L43.1373 62.1162L43.0907 62.56Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-86-inside-17_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.413 46.1381L258.766 78.6963C258.834 79.2011 259.27 79.5745 259.779 79.5635L264.272 79.4664C264.867 79.4536 265.319 78.9269 265.242 78.3368L260.996 45.917L266.022 37.1753H249.259L254.413 46.1381Z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.413 46.1381L258.766 78.6963C258.834 79.2011 259.27 79.5745 259.779 79.5635L264.272 79.4664C264.867 79.4536 265.319 78.9269 265.242 78.3368L260.996 45.917L266.022 37.1753H249.259L254.413 46.1381Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M258.766 78.6963L257.775 78.8288L258.766 78.6963ZM254.413 46.1381L255.404 46.0056L255.378 45.8104L255.28 45.6397L254.413 46.1381ZM259.779 79.5635L259.801 80.5633H259.801L259.779 79.5635ZM264.272 79.4664L264.25 78.4666H264.25L264.272 79.4664ZM265.242 78.3368L266.233 78.2069V78.2069L265.242 78.3368ZM260.996 45.917L260.129 45.4185L259.96 45.7116L260.004 46.0469L260.996 45.917ZM266.022 37.1753L266.889 37.6738L267.751 36.1753H266.022V37.1753ZM249.259 37.1753V36.1753H247.531L248.392 37.6738L249.259 37.1753ZM259.757 78.5637L255.404 46.0056L253.422 46.2707L257.775 78.8288L259.757 78.5637ZM259.757 78.5637H259.757L257.775 78.8288C257.91 79.8384 258.782 80.5853 259.801 80.5633L259.757 78.5637ZM264.25 78.4666L259.757 78.5637L259.801 80.5633L264.293 80.4662L264.25 78.4666ZM264.25 78.4666L264.25 78.4666L264.293 80.4662C265.483 80.4405 266.388 79.3872 266.233 78.2069L264.25 78.4666ZM260.004 46.0469L264.25 78.4666L266.233 78.2069L261.987 45.7871L260.004 46.0469ZM261.863 46.4155L266.889 37.6738L265.155 36.6769L260.129 45.4185L261.863 46.4155ZM266.022 36.1753H249.259V38.1753H266.022V36.1753ZM248.392 37.6738L253.546 46.6366L255.28 45.6397L250.126 36.6769L248.392 37.6738Z",
    fill: "#303030",
    mask: "url(#path-86-inside-17_127_731)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7134 66.3286H154.512L155.24 78.7187H78.7134V66.3286Z",
    fill: "#303030"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7559 63.6843C77.7559 63.4082 77.9797 63.1843 78.2559 63.1843H154.969C155.246 63.1843 155.469 63.4082 155.469 63.6843V66.7861C155.469 67.0623 155.246 67.2861 154.969 67.2861H78.2559C77.9797 67.2861 77.7559 67.0623 77.7559 66.7861V63.6843Z",
    fill: "white",
    stroke: "#303030"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 239.056,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 192.411,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 143.58,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 216.462,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 169.817,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 118.07,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 92.561,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 67.0522,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 43.001,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 230.31,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 183.665,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 134.833,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 207.716,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 161.071,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 109.324,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 83.8154,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3062,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2549,
    y: 39.3618,
    width: 5.10181,
    height: 2.18649,
    rx: 0.2,
    fill: "#303030"
  })), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-108-inside-18_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2715 47.0562L14.1427 78.5787C14.0654 79.1689 14.5176 79.6955 15.1127 79.7084L19.6053 79.8055C20.1145 79.8165 20.5506 79.443 20.6181 78.9382L24.9251 46.7272L30.6108 37.1753H12.39L18.2715 47.0562Z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2715 47.0562L14.1427 78.5787C14.0654 79.1689 14.5176 79.6955 15.1127 79.7084L19.6053 79.8055C20.1145 79.8165 20.5506 79.443 20.6181 78.9382L24.9251 46.7272L30.6108 37.1753H12.39L18.2715 47.0562Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2715 47.0562L19.2631 47.1861L19.3081 46.8425L19.1308 46.5447L18.2715 47.0562ZM14.1427 78.5787L13.1512 78.4489H13.1512L14.1427 78.5787ZM15.1127 79.7084L15.1343 78.7086H15.1343L15.1127 79.7084ZM19.6053 79.8055L19.6269 78.8057H19.6269L19.6053 79.8055ZM20.6181 78.9382L19.6269 78.8057L20.6181 78.9382ZM24.9251 46.7272L24.0658 46.2158L23.9611 46.3917L23.9339 46.5947L24.9251 46.7272ZM30.6108 37.1753L31.4701 37.6868L32.3698 36.1753H30.6108V37.1753ZM12.39 37.1753V36.1753H10.6311L11.5307 37.6868L12.39 37.1753ZM17.28 46.9264L13.1512 78.4489L15.1343 78.7086L19.2631 47.1861L17.28 46.9264ZM13.1512 78.4489C12.9966 79.6292 13.9009 80.6824 15.0911 80.7081L15.1343 78.7086L15.1343 78.7086L13.1512 78.4489ZM15.0911 80.7081L19.5837 80.8052L19.6269 78.8057L15.1343 78.7086L15.0911 80.7081ZM19.5837 80.8052C20.602 80.8272 21.4743 80.0804 21.6093 79.0708L19.6269 78.8057L19.5837 80.8052ZM21.6093 79.0708L25.9163 46.8598L23.9339 46.5947L19.6269 78.8057L21.6093 79.0708ZM25.7844 47.2387L31.4701 37.6868L29.7515 36.6638L24.0658 46.2158L25.7844 47.2387ZM30.6108 36.1753H12.39V38.1753H30.6108V36.1753ZM11.5307 37.6868L17.4122 47.5677L19.1308 46.5447L13.2493 36.6638L11.5307 37.6868Z",
    fill: "#303030",
    mask: "url(#path-108-inside-18_127_731)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29.8818,
    y1: 44.6924,
    x2: 249.988,
    y2: 44.6924,
    stroke: "#303030"
  })), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-111-inside-19_127_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 28.4294C0.447715 28.4294 0 28.8772 0 29.4294V33.2601C0 33.8124 0.447708 34.2601 0.999993 34.2601H3.64417V36.9042C3.64417 37.4565 4.09188 37.9042 4.64417 37.9042H270.125C270.677 37.9042 271.125 37.4565 271.125 36.9042V34.2601H273.769C274.321 34.2601 274.769 33.8124 274.769 33.2601V29.4294C274.769 28.8772 274.321 28.4294 273.769 28.4294H1Z"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 28.4294C0.447715 28.4294 0 28.8772 0 29.4294V33.2601C0 33.8124 0.447708 34.2601 0.999993 34.2601H3.64417V36.9042C3.64417 37.4565 4.09188 37.9042 4.64417 37.9042H270.125C270.677 37.9042 271.125 37.4565 271.125 36.9042V34.2601H273.769C274.321 34.2601 274.769 33.8124 274.769 33.2601V29.4294C274.769 28.8772 274.321 28.4294 273.769 28.4294H1Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64417 34.2601H4.64417V33.2601H3.64417V34.2601ZM271.125 34.2601V33.2601H270.125V34.2601H271.125ZM1 29.4294V29.4294V27.4294C-0.104571 27.4294 -1 28.3249 -1 29.4294H1ZM1 33.2601V29.4294H-1V33.2601H1ZM0.999993 33.2601H1H-1C-1 34.3646 -0.104586 35.2601 0.999993 35.2601V33.2601ZM3.64417 33.2601H0.999993V35.2601H3.64417V33.2601ZM4.64417 36.9042V34.2601H2.64417V36.9042H4.64417ZM4.64417 36.9042H4.64417H2.64417C2.64417 38.0088 3.53959 38.9042 4.64417 38.9042V36.9042ZM270.125 36.9042H4.64417V38.9042H270.125V36.9042ZM270.125 36.9042V38.9042C271.229 38.9042 272.125 38.0088 272.125 36.9042H270.125ZM270.125 34.2601V36.9042H272.125V34.2601H270.125ZM273.769 33.2601H271.125V35.2601H273.769V33.2601ZM273.769 33.2601V33.2601V35.2601C274.873 35.2601 275.769 34.3647 275.769 33.2601H273.769ZM273.769 29.4294V33.2601H275.769V29.4294H273.769ZM273.769 29.4294V29.4294H275.769C275.769 28.3249 274.873 27.4294 273.769 27.4294V29.4294ZM1 29.4294H273.769V27.4294H1V29.4294Z",
    fill: "#303030",
    mask: "url(#path-111-inside-19_127_731)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.28809,
    y1: 33.76,
    x2: 267.48,
    y2: 33.76,
    stroke: "#303030"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 167.172,
    y1: 11.6246,
    x2: 170.087,
    y2: 81.5922,
    stroke: "#303030",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M163.704 23.3835L166.477 14.9265L167.228 29.2224C164.528 28.7675 162.843 26.0085 163.704 23.3835Z",
    fill: "white",
    stroke: "#9A9A9A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M166.413 24.3513L165.111 25.3686L166.596 26.093L166.413 24.3513Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M165.285 24.4699L166.77 25.1943L165.468 26.2115L165.285 24.4699Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 170.087,
    y1: 5.06968,
    x2: 173.003,
    y2: 83.7832,
    stroke: "#303030",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M166.312 21.1755L169.839 10.4185L170.717 27.1344L169.995 27.0384C167.203 26.6671 165.434 23.8516 166.312 21.1755Z",
    fill: "white",
    stroke: "#9A9A9A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M169.328 22.1648L168.026 23.1821L169.511 23.9065L169.328 22.1648Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M168.2 22.2831L169.685 23.0075L168.383 24.0248L168.2 22.2831Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 173.003,
    y1: 0.691191,
    x2: 176.647,
    y2: 85.9642,
    stroke: "#303030",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M168.331 17.0224L172.844 3.26041L173.887 23.1344L172.014 22.8853C169.222 22.514 167.454 19.6985 168.331 17.0224Z",
    fill: "white",
    stroke: "#9A9A9A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M171.446 17.0066L170.144 18.0239L171.629 18.7483L171.446 17.0066Z",
    fill: "white",
    stroke: "#9B9A95"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M170.319 17.1249L171.804 17.8493L170.502 18.8666L170.319 17.1249Z",
    fill: "white",
    stroke: "#9B9A95"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnessetInBreake);
export default __webpack_public_path__ + "static/media/knessetInBreake.8a36f2a6418e2d9b0cd365180d395b15.svg";
export { ForwardRef as ReactComponent };